import { auth, database } from "firebase";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { GlobalStyles } from "src/global-styles";
import theme from "src/theme";
import { ThemeProvider } from "styled-components";
import AppPresenter from "./AppPresenter";
import Loader from "src/Components/Loader";
import { useQuery } from "@apollo/client";
import { GET_BUSINESS_INFO } from "./AppQueries.local";
import LanguageProvider from "src/Context/LanguageProvider";
import { AppStore } from "src/Context/AppStore";
// import "../../styles/style.scss";
import { Helmet, HelmetProvider } from "react-helmet-async";

const LoadingWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const { data, loading, error } = useQuery(GET_BUSINESS_INFO);

  useEffect(() => {
    auth().onAuthStateChanged(async (user) => {
      if (user) {
        let user = auth().currentUser;
        if (user) {
          const token = await user.getIdToken();
          const idTokenResult = await user.getIdTokenResult();
          const hasuraClaim =
            idTokenResult.claims["https://hasura.io/jwt/claims"];

          if (hasuraClaim) {
            if (
              hasuraClaim["x-hasura-default-role"] === "admin" ||
              hasuraClaim["x-hasura-default-role"] === "master"
            ) {
              setIsAdmin(true);
            } else {
              setIsAdmin(false);
            }
            localStorage.setItem("token", token);
            setIsLoggedIn(true);
          } else {
            const metadataRef = database().ref(
              "metadata/" + user.uid + "/refreshTime"
            );

            metadataRef.on("value", async (data) => {
              if (!data.exists) {
                return;
              }

              let token = await user?.getIdToken(true);
              if (token) {
                localStorage.setItem("token", token);
                setTimeout(() => {
                  setIsLoggedIn(true);
                });
              }
            });
          }
        }
      } else {
        setIsLoggedIn(false);
      }
    });
  }, [data, loading, error]);

  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <title>
            {!loading && data && data.master && data.master.length > 0
              ? data.master[0].company_name
              : "Loading..."}
          </title>
        </Helmet>
        <AppStore.Provider
          value={
            !loading && data && data.master && data.master.length > 0
              ? data.master[0]
              : {
                  company_logo: null,
                  company_name: "Company Name",
                }
          }
        >
          <LanguageProvider>
            <ThemeProvider
              theme={
                data?.master?.length > 0 && data?.master[0].theme
                  ? { ...theme, ...JSON.parse(data?.master[0]?.theme) }
                  : theme
              }
            >
              <GlobalStyles />
              {isLoggedIn !== null ? (
                <AppPresenter isLoggedIn={isLoggedIn} isAdmin={isAdmin} />
              ) : (
                <LoadingWrapper>
                  <Loader message="Checking connection..." />
                </LoadingWrapper>
              )}
              <ToastContainer draggable={true} position={"top-center"} />
            </ThemeProvider>
          </LanguageProvider>
        </AppStore.Provider>
      </div>
    </HelmetProvider>
  );
}

export default App;
